import { Koi } from '@ksyos/koi';
import { DayOfWeek } from '../enums/dayOfWeek';

export interface ICallBackMomentAddEdit {
    dayOfWeek: DayOfWeek;
    isChecked: boolean;
    periodOne: ITimeRange;
    periodTwo: ITimeRange;
}

export interface ITimeRange {
    endTime: string | null;
    startTime: string | null;
}

const callBackMomentAddEditBase = Koi.object({
    dayOfWeek: Koi.koi().enum(DayOfWeek),
    isChecked: Koi.boolean(),
});

const draftPeriod = Koi.object({
    endTime: Koi.koi().timeWithoutSeconds().allow(null),
    startTime: Koi.koi().timeWithoutSeconds().allow(null),
});

export const partialCallBackMomentAddEditObject = callBackMomentAddEditBase.keys({
    periodOne: draftPeriod,
    periodTwo: draftPeriod,
});

const finalPeriodOptional = Koi.object({
    endTime: Koi.when('startTime', {
        is: null,
        otherwise: Koi.koi().timeWithoutSeconds().disallow(null),
        then: Koi.valid(null),
    }),
    startTime: Koi.koi().timeWithoutSeconds().allow(null),
});

const finalPeriod = Koi.object({
    endTime: Koi.koi().timeWithoutSeconds().disallow(null),
    startTime: Koi.koi().timeWithoutSeconds().disallow(null),
});

export const finalCallBackMoment = Koi.alternatives().try(
    Koi.object({
        dayOfWeek: Koi.koi().enum(DayOfWeek),
        isChecked: Koi.boolean().valid(false),
        periodOne: draftPeriod,
        periodTwo: draftPeriod,
    }),
    Koi.object({
        dayOfWeek: Koi.koi().enum(DayOfWeek),
        isChecked: Koi.boolean().valid(true),
        periodOne: finalPeriod,
        periodTwo: finalPeriodOptional,
    }),
    Koi.object({
        dayOfWeek: Koi.koi().enum(DayOfWeek),
        isChecked: Koi.boolean().valid(true),
        periodOne: finalPeriodOptional,
        periodTwo: finalPeriod,
    })
);
